import React, { Component, Fragment } from 'react';
import axios from "axios";
import { Input, Row, Col, FormFeedback, Label, Card, CardTitle, CardBody, Button } from 'reactstrap';

import api from '../../../api/api';

import Modal from "./Modal"
import ModalCuenta from "./ModalCuenta"
import { format } from '../../../functions/functions';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker.js"
import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable"

import DateFilter from "../../../components/ParadigmaTable/DateFilter";

import moment from 'moment';

class MovimientosCajaCuentas extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha",
                    accessor: d => moment(d.fecha).format('DD/MM/YYYY'),
                    className: "text-center",
                    show: true,
                    width: 100,
                    exportWidth: "50",
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Caja",
                    id: "caja",
                    accessor: d => d.caja ? d.caja.nombre : '',
                    show: false,
                    private: true,
                    exportWidth: "100",
                },
                {
                    Header: "Caja",
                    id: "caja__nombre",
                    // accessor: d => d.caja ? d.caja.nombre : '',
                    accessor: 'caja__nombre',
                    show: true,
                    exportWidth: "100",
                    Filter: ({ filter, onChange }) =>
                            <ParadigmaAsyncSeeker
                                clearable
                                url={api.caja.caja}
                                value={(filter && filter.value) ? filter.value.input : ""}
                                valueField={'nombre'}
                                onChange={data => (data) ? (onChange({lookup: null, input: data.nombre})): ((filter) ? onChange('') : null)}
                            />
                },
                {
                    Header: "Cuenta",
                    id: "cuenta",
                    accessor: d => d.cuenta ? d.cuenta.nombre : '',
                    show: false,
                    private: true,
                    exportWidth: "100",
                },
                {
                    Header: "Cuenta",
                    id: "cuenta__nombre",
                    // accessor: d => d.cuenta ? d.cuenta.nombre : '',
                    accessor: 'cuenta__nombre',
                    show: true,
                    exportWidth: "100",
                    Filter: ({ filter, onChange }) =>
                            <ParadigmaAsyncSeeker
                                clearable
                                url={api.caja.cuentas}
                                value={(filter && filter.value) ? filter.value.input : ""}
                                valueField={'nombre'}
                                onChange={data => (data) ? (onChange({lookup: null, input: data.nombre})): ((filter) ? onChange('') : null)}
                            />
                },
                {
                    Header: "Tipo Movimiento",
                    id: "nombre_tipoMovimiento",
                    // accessor: d => d.tipoMovimiento==0 ? 'Ingreso' : 'Egreso',
                    accessor: 'nombre_tipoMovimiento',
                    show: true,
                    exportWidth: "100",
                    Filter: ({ filter, onChange }) =>
                        <ParadigmaAsyncSeeker
                                clearable
                                url={undefined}
                                optionDefault={[{nombre: 'Ingreso', id: 'Ingreso'}, {nombre: 'Egreso', id: 'Egreso'}]}
                                value={(filter && filter.value) ? filter.value.input : ""}
                                onChange={data => (data) ? (onChange({lookup: null, input: data.id})): ((filter) ? onChange('') : null)}
                            />
                },
                {
                    Header: "Monto",
                    id: "monto",
                    // accessor: 'monto',
                    className: 'text-rigth',
                    exportWidth: "120",
                    accessor: d => (d.monto > 0) ? `$ ${format(d.monto)}` : '-',
                    show: true,
                    exportCurrency: true,
                },
                {
                    Header: "Observación",
                    id: "observacion",
                    accessor: 'observacion',
                    show: true,
                    exportWidth: "150",
                },
            ],
            filtros: {
                desde: moment(),
                hasta: moment(),
                caja_id: null,
                sinCuentas: true,
            },
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        const { desde, hasta, caja_id, sinCuentas } = this.state.filtros;
        let outerFilter = [];

        if (desde && hasta) {
            outerFilter.push({
                id: 'fecha',
                value: {
                    lookup: 'date__range',
                    input: `${moment(desde).format('YYYY-MM-DD')},${moment(hasta).format('YYYY-MM-DD')}`,
                }
            });
        }
        
        if (sinCuentas==true){
            outerFilter.push({
                id: 'cuenta__nombre',
                value: {
                    lookup: 'exact',
                    input: ''
                }
            })
        }
        
        return (
            <Fragment>
                <Row className={'mt-1'}>
                    <Col className="col-12">
                        <Card body className="border-0 p-0 mb-3">
                            <CardTitle className="text-center py-2 mb-0 rep_color">
                                Filtros
                            </CardTitle>
                            <CardBody>
                                <Row>
                                    <Col className="col-12 col-md-4 col-lg-4 mr-2">
                                        <ParadigmaLabeledInput
                                            label="Período"
                                            md={[3, 9]}
                                            // classNames={['repFiltroLbl','']}
                                            inputComponent={
                                                <Row>
                                                    <Col className="col-6 col-md-12 col-lg-12 col-xl-6 mb-0 mb-md-1 mb-xl-0 pr-1">
                                                        <ParadigmaDatePicker fieldName={"fechaInicio"}
                                                            datetime={false}
                                                            placeholder={"Desde"}
                                                            icon={"fa fa-calendar"}
                                                            value={desde}
                                                            className={'repFechaInp'}
                                                            onChange={data => this.setState(prevState => ({
                                                                filtros: {
                                                                    ...prevState.filtros,
                                                                    desde: data
                                                                }
                                                            }))}
                                                        />
                                                    </Col>
                                                    <Col className="col-6 col-md-12 col-lg-12 col-xl-6 pl-1">
                                                        <ParadigmaDatePicker fieldName={"fechaFin"}
                                                            datetime={false}
                                                            placeholder={"Hasta"}
                                                            icon={"fa fa-calendar"}
                                                            value={hasta}
                                                            className={'repFechaInp fhasta'}
                                                            onChange={data => this.setState(prevState => ({
                                                                filtros: {
                                                                    ...prevState.filtros,
                                                                    hasta: data
                                                                }
                                                            }))}
                                                        />
                                                    </Col>
                                                </Row>
                                            }
                                        />
                                    </Col>
                                    <Col className="col-12 col-md-3 col-lg-2 pt-1">
                                        <div className="custom-control custom-switch text-left my-auto control-switch-interes">
                                                <input type="checkbox" className="custom-control-input" id="customSwitchAplicarInteres" checked={sinCuentas}/>
                                                <label className="custom-control-label" htmlFor="customSwitchAplicarInteres" onClick={(evt) => this.setState(prevState => ({
                                                                filtros: {
                                                                    ...prevState.filtros,
                                                                    sinCuentas: !sinCuentas
                                                                }
                                                            }))}>Sin Cuentas</label>
                                        </div>
                                    </Col>
                                    {/* <Col className="col-12 col-md-4 col-lg-3">
                                        <ParadigmaLabeledInput
                                            md={[3, 9]}
                                            label={"Caja"}
                                            inputComponent={
                                                <ParadigmaAsyncSeeker
                                                    url={api.caja.caja}
                                                    clearable={true}
                                                    value={caja_id}
                                                    parameters={{
                                                        paginationEnabled:false,
                                                        sort:['nombre'],
                                                    }}
                                                    onChange={data => {this.setState(prevState => ({
                                                                                        filtros: {
                                                                                            ...prevState.filtros,
                                                                                            caja_id: (data) ? (data.id) : (null),
                                                                                        }
                                                                                    }))}}
                                                />
                                            }
                                        />
                                    </Col> */}
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col className={'col-12'}>
                        <ParadigmaTable
                            buttons={[
                                {
                                    createmultiSelect: true,
                                    component: (props) => <Modal {...props} action="CREATE" />,
                                    permission: 'caja_caja_new',
                                },
                                {
                                    createmultiSelect: true,
                                    component: (props) => <Modal {...props} action="EDIT" />,
                                    permission: 'caja_caja_edit',
                                },
                                {
                                    createmultiSelect: true,
                                    component: (props) => <Modal {...props} action="DETAIL" />,
                                    permission: 'caja_caja_detail',
                                },
                                {
                                    createmultiSelect: true,
                                    component: (props) => <Modal {...props} action="DELETE" />,
                                    permission: 'caja_caja_delete',
                                },
                                {
                                    createmultiSelect: true,
                                    component: (props) => <ModalCuenta {...props} action="CREATE" />,
                                    permission: 'caja_caja_new',
                                },
                            ]}
                            apiUrl={api.caja.movimientosCaja}
                            columns={this.state.columns}
                            outerFilter={[...outerFilter,]}
                            multiSelect={true}
                            exportUrl={api.caja.movimientosCaja}
                            title={"Movimientos de Caja"}
                        />
                    </Col>
                </Row>
            </Fragment>
        );
    }
}

export default MovimientosCajaCuentas;



// WEBPACK FOOTER //
// ./src/views/Caja/MovimientosCajaCuentas/MovimientosCajaCuentas.js